var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-template",
    [
      _c("template", { slot: "page-content" }, [
        _c("div", { staticClass: "generic--template page-template pb5" }, [
          _c("div", { staticClass: "relative z-content" }, [
            _c(
              "div",
              { staticClass: "relative container-fluid mw8-5 center" },
              [
                _c(
                  "div",
                  { staticClass: "row relative center mb0 mb4-ns mt4-ns" },
                  [
                    _c(
                      "div",
                      { staticClass: "w-100 relative col-xs-12 col-sm-6" },
                      [
                        _vm.page.has_bg_video
                          ? _c("bg-vimeo-video", {
                              attrs: {
                                vimeoVideoId:
                                  _vm.page.background_video_vimeo_id,
                              },
                            })
                          : _c("img", {
                              staticClass: "img-responsive",
                              attrs: { src: _vm.page.hero_image },
                            }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "relative col-xs-12 col-sm-6" }, [
                      _c(
                        "span",
                        {
                          staticClass:
                            "db dn-ns mt4 nb0 f3 is-tablet-bold tl ttu is-teal",
                        },
                        [_vm._v("Neighborhood")]
                      ),
                      _vm._v(" "),
                      _c(
                        "h1",
                        {
                          staticClass:
                            "db dn-ns mt0 mb3 f-page-title ttu tl center lh-heading pr0-ns is-blenny is-navy mw7-ns",
                        },
                        [_vm._v(_vm._s(_vm.page.title_copy))]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "dn db-ns abs-vert-center center pl5-ns",
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "db nb3 f3 is-tablet-bold tl ttu is-teal",
                            },
                            [_vm._v("Neighborhood")]
                          ),
                          _vm._v(" "),
                          _c(
                            "h1",
                            {
                              staticClass:
                                "mw7-ns mv1 tc center lh-heading f-page-title ttu is-blenny is-navy",
                            },
                            [_vm._v(_vm._s(_vm.page.title_copy))]
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c("section", { staticClass: "relative" }, [
              _c(
                "div",
                { staticClass: "relative container-fluid mw8-5 center" },
                [
                  _c("div", { staticClass: "row center" }, [
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-8 mt0 mt4-ns" },
                      [
                        _vm.page.about_section.intro_text
                          ? _c("div", {
                              staticClass:
                                "f15px is-tablet-regular link-bold lh-copy mw7",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.marked(_vm.page.about_section.intro_text)
                                ),
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "row mr2-ns mt4 mt5-ns" },
                          [
                            _c("div", { staticClass: "col-sm-12" }, [
                              _c(
                                "h2",
                                {
                                  staticClass:
                                    "f2 ttu is-tablet-bold is-navy mb5",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.page.merchant_highlights_section.title
                                    )
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _vm._l(
                              _vm.page.merchant_highlights_section
                                .content_blocks,
                              function (block, index) {
                                return _c("div", { staticClass: "col-sm-6" }, [
                                  _c(
                                    "h4",
                                    {
                                      staticClass:
                                        "dib mr2 f20px is-tablet-bold is-navy",
                                    },
                                    [_vm._v(_vm._s(block.title))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "dib f15px is-tablet-bold is-light-grey",
                                    },
                                    [_vm._v(_vm._s(block.address))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "f15px is-tablet-regular lh-copy mv1",
                                    },
                                    [_vm._v(_vm._s(block.text))]
                                  ),
                                  _vm._v(" "),
                                  block.link
                                    ? _c(
                                        "a",
                                        {
                                          staticClass:
                                            "f15px db mt3 ttu is-tablet-regular mb4 pointer",
                                          attrs: {
                                            href: block.link,
                                            title: "Store Website",
                                          },
                                        },
                                        [_vm._v("Store Website ↗")]
                                      )
                                    : _vm._e(),
                                ])
                              }
                            ),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "row mr2-ns" },
                          [
                            _c("div", { staticClass: "col-sm-12" }, [
                              _c(
                                "h2",
                                { staticClass: "f30px is-lorano-bold mt5 mb5" },
                                [
                                  _vm._v(
                                    _vm._s(_vm.page.good_eats_section.title)
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _vm._l(
                              _vm.page.good_eats_section.content_blocks,
                              function (block, index) {
                                return _c("div", { staticClass: "col-sm-6" }, [
                                  _c(
                                    "h4",
                                    {
                                      staticClass:
                                        "dib mr2 f20px is-tablet-bold is-navy",
                                    },
                                    [_vm._v(_vm._s(block.title))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "dib f15px is-tablet-bold is-light-grey",
                                    },
                                    [_vm._v(_vm._s(block.address))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "f15px is-tablet-regular lh-copy mv1",
                                    },
                                    [_vm._v(_vm._s(block.text))]
                                  ),
                                  _vm._v(" "),
                                  block.link
                                    ? _c(
                                        "a",
                                        {
                                          staticClass:
                                            "f15px ttu db mt3 is-tablet-regular mb4 pointer",
                                          attrs: {
                                            href: block.link,
                                            title: "Store Website",
                                          },
                                        },
                                        [_vm._v("Store Website ↗")]
                                      )
                                    : _vm._e(),
                                ])
                              }
                            ),
                          ],
                          2
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-sm-4" }, [
                      _c(
                        "div",
                        { staticClass: "dn db-ns icon-image relative" },
                        [
                          _c("img", {
                            attrs: { src: _vm.page.secondary_image },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.page.about_section.hood_links
                        ? _c(
                            "div",
                            { staticClass: "db relative mv4 pa4 bg-navy" },
                            [
                              _c(
                                "h3",
                                {
                                  staticClass:
                                    "f20px is-tablet-bold mb4 ttu is-beige",
                                },
                                [_vm._v("Links About The Hood")]
                              ),
                              _vm._v(" "),
                              _c("div", {
                                staticClass:
                                  "db absolute left-0 right-0 w-100 absolute horiz-line-beige",
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "db relative mt5" },
                                _vm._l(
                                  _vm.page.about_section.hood_links,
                                  function (item) {
                                    return item.link
                                      ? _c(
                                          "a",
                                          {
                                            staticClass:
                                              "f15px is-tablet-regular db pb3 is-yellow",
                                            attrs: {
                                              href: item.link,
                                              target: "_blank",
                                              title: item.title,
                                            },
                                          },
                                          [_vm._v(_vm._s(item.title))]
                                        )
                                      : _vm._e()
                                  }
                                ),
                                0
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ]),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _vm.isWindowWidthMobile == true &&
          _vm.page.featured_content_section.is_published
            ? _c(
                "div",
                { staticClass: "relative bg-light-blue z-content mb5" },
                [
                  _c(
                    "section",
                    { staticClass: "relative center pv4 is-black" },
                    [
                      _c(
                        "swiper",
                        {
                          ref: "mySwiper",
                          attrs: { options: _vm.swiperOptions },
                        },
                        [
                          _c("swiper-slide", [
                            _c(
                              "div",
                              { staticClass: "relative container-fluid" },
                              [
                                _c("div", { staticClass: "db w-100" }, [
                                  _c("img", {
                                    staticClass:
                                      "db relative center img-responsive w-100",
                                    attrs: {
                                      src: _vm.page.featured_content_section
                                        .content["0"].image,
                                      alt: _vm.page.featured_content_section
                                        .content["0"].image.alt,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "h3",
                                    {
                                      staticClass:
                                        "f20px is-tablet-cond-bold mt4 mb3",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.page.featured_content_section
                                            .content["0"].title
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "f15px is-tablet-regular mb3 lh-copy",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.page.featured_content_section
                                            .content["0"].text
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "f15px is-tablet-bold",
                                      attrs: {
                                        title:
                                          _vm.page.featured_content_section
                                            .content["0"].link_title,
                                        href: _vm.page.featured_content_section
                                          .content["0"].link,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.page.featured_content_section
                                            .content["0"].button_text
                                        )
                                      ),
                                      _c("simple-svg", {
                                        staticClass: "checkout",
                                        attrs: {
                                          filepath:
                                            "/uploads/checkout-arrow.svg",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("swiper-slide", [
                            _c(
                              "div",
                              { staticClass: "relative container-fluid" },
                              [
                                _c("div", { staticClass: "db w-100" }, [
                                  _c("img", {
                                    staticClass:
                                      "db relative center img-responsive w-100",
                                    attrs: {
                                      src: _vm.page.featured_content_section
                                        .content["1"].image,
                                      alt: _vm.page.featured_content_section
                                        .content["1"].image.alt,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "h3",
                                    {
                                      staticClass:
                                        "f20px is-tablet-cond-bold mt4 mb3",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.page.featured_content_section
                                            .content["1"].title
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "f15px is-tablet-regular mb3 lh-copy",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.page.featured_content_section
                                            .content["1"].text
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "f15px is-tablet-bold",
                                      attrs: {
                                        title:
                                          _vm.page.featured_content_section
                                            .content["1"].link_title,
                                        href: _vm.page.featured_content_section
                                          .content["1"].link,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.page.featured_content_section
                                            .content["1"].button_text
                                        )
                                      ),
                                      _c("simple-svg", {
                                        staticClass: "checkout",
                                        attrs: {
                                          filepath:
                                            "/uploads/checkout-arrow.svg",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isWindowWidthMobile == false &&
          _vm.page.featured_content_section.is_published
            ? _c(
                "div",
                { staticClass: "relative bg-light-blue z-content mb5 mt4" },
                [
                  _c("div", { staticClass: "relative container-fluid" }, [
                    _c(
                      "section",
                      { staticClass: "relative center mw8 pt5 pb5 is-black" },
                      [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-xs-12 col-sm-6 pr5-ns br-ns b--is-cream",
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "post-link",
                                  attrs: {
                                    href: _vm.page.featured_content_section
                                      .content["0"].link,
                                    title:
                                      "View " +
                                      _vm.page.featured_content_section.content[
                                        "0"
                                      ].title,
                                  },
                                },
                                [
                                  _c("div", {
                                    staticClass: "news-zoom aspect-ratio--16x9",
                                    style: {
                                      background:
                                        "url(" +
                                        _vm.page.featured_content_section
                                          .content["0"].image +
                                        ")",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "h3",
                                    {
                                      staticClass:
                                        "f20px is-tablet-cond-bold mt4 mb3 is-black",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.page.featured_content_section
                                            .content["0"].title
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "f15px is-tablet-regular mb3 lh-copy dib",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.page.featured_content_section.content[
                                        "0"
                                      ].text
                                    )
                                  ),
                                  _vm.page.featured_content_section.content["0"]
                                    .link
                                    ? _c(
                                        "a",
                                        {
                                          staticClass:
                                            "f15px is-tablet-bold dib",
                                          attrs: {
                                            title:
                                              _vm.page.featured_content_section
                                                .content["1"].link_title,
                                            href: _vm.page
                                              .featured_content_section.content[
                                              "0"
                                            ].link,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.page.featured_content_section
                                                .content["1"].button_text
                                            )
                                          ),
                                          _c("simple-svg", {
                                            staticClass: "checkout",
                                            attrs: {
                                              filepath:
                                                "/uploads/checkout-arrow.svg",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-xs-12 col-sm-6 pl5-ns pt5 pt0-m pt0-l ",
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "post-link",
                                  attrs: {
                                    href: _vm.page.featured_content_section
                                      .content["1"].link,
                                    title:
                                      "View " +
                                      _vm.page.featured_content_section.content[
                                        "1"
                                      ].title,
                                  },
                                },
                                [
                                  _c("div", {
                                    staticClass: "news-zoom aspect-ratio--16x9",
                                    style: {
                                      background:
                                        "url(" +
                                        _vm.page.featured_content_section
                                          .content["1"].image +
                                        ")",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "h3",
                                    {
                                      staticClass:
                                        "f20px is-tablet-cond-bold mt4 mb3 is-black",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.page.featured_content_section
                                            .content["1"].title
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "f15px is-tablet-regular mb3 lh-copy dib",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.page.featured_content_section.content[
                                        "1"
                                      ].text
                                    ) + " "
                                  ),
                                  _vm.page.featured_content_section.content["1"]
                                    .link
                                    ? _c(
                                        "a",
                                        {
                                          staticClass:
                                            "f15px is-tablet-bold dib",
                                          attrs: {
                                            title:
                                              _vm.page.featured_content_section
                                                .content["1"].link_title,
                                            href: _vm.page
                                              .featured_content_section.content[
                                              "1"
                                            ].link,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.page.featured_content_section
                                                .content["1"].button_text
                                            )
                                          ),
                                          _c("simple-svg", {
                                            staticClass: "checkout",
                                            attrs: {
                                              filepath:
                                                "/uploads/checkout-arrow.svg",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]
              )
            : _vm._e(),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }